import store from "../store";
import Constants from "../config/constants";
import { serviceGetStaffList, serviceCreateStaff } from "../services/AdminUser.service";
import EventEmitter from "../libs/Events.utils";
import { STAFF_TYPE } from "../services/AdminUser.service";

export const FETCH_INIT = "FETCH_INIT_EMPLOYEE";
export const FETCHED = "FETCHED_EMPLOYEE";
export const FETCHED_FAIL = "FETCHED_FAIL_EMPLOYEE";
export const FETCHED_FILTER = "FETCHED_FILTER_EMPLOYEE";
export const NEXT_PREQUESTS = "NEXT_PREQUESTS_EMPLOYEE";
export const PREV_PREQUESTS = "PREV_PREQUESTS_EMPLOYEE";
export const FETCH_NEXT = "FETCH_NEXT_EMPLOYEE";
export const FILTER = "FILTER_EMPLOYEE";
export const RESET_FILTER = "RESET_FILTER_EMPLOYEE";
export const SET_SORTING = "SET_SORTING_EMPLOYEE";
export const SET_FILTER = "SET_FILTER_EMPLOYEE";
export const SET_PAGE = "SET_PAGE_EMPLOYEE";
export const CHANGE_PAGE = "CHANGE_PAGE_EMPLOYEE";
export const CHANGE_STATUS = "CHANGE_STATE_EMPLOYEE";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_EMPLOYEE";
export const CREATE_DATA = "CREATE_EMPLOYEE";
export const UPDATE_DATA = "UPDATE_EMPLOYEE";
export const DELETE_ITEM = "DELETE_EMPLOYEE";
export const PERMISSION = "PERMISSION_EMPLOYEE";

export function actionFetchEmployees(index = 1, sorting = {}, filter = {}) {
  const payload = {
    pageId: (index || 1) - 1,
    ...filter,
  };
  let typeVal = filter.type;
  if ((typeVal == null || typeVal === "") && Array.isArray(filter.query_data)) {
    const typeItem = filter.query_data.find((f) => f.name === "type");
    if (typeItem && typeItem.value) typeVal = typeItem.value;
  }
  if (typeVal != null && typeVal !== "") {
    payload.type = typeVal;
  } else {
    payload.type = [STAFF_TYPE.LEAD, STAFF_TYPE.TELECALLER];
  }
  const request = serviceGetStaffList(payload);
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        const list = Array.isArray(data?.response_obj) ? data.response_obj : (Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []));
        dispatch({ type: FETCHED, payload: { data: list, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionCreateEmployee(data) {
  const type = data.type === STAFF_TYPE.LEAD ? STAFF_TYPE.LEAD : STAFF_TYPE.TELECALLER;
  const request = serviceCreateStaff({ ...data, type });
  return (dispatch) => {
    request.then((data) => {
      if (!data.error) {
        EventEmitter.dispatch(EventEmitter.THROW_ERROR, { error: "Saved", type: "success" });
        dispatch({ type: CREATE_DATA, payload: data.data });
      }
    });
  };
}

export function actionChangePageEmployee(page) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, payload: page });
  };
}

export function nextPRequestsClick() {
  return {
    type: NEXT_PREQUESTS,
    payload: null,
  };
}

export function actionFilterEmployee(value) {
  const request = null;
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: FILTER, payload: data });
      dispatch({ type: FETCHED, payload: null });
    });
  };
}

export function actionChangeStatusEmployee(id, status) {
  return (dispatch) => {
    dispatch({ type: CHANGE_STATUS, payload: { id, status } });
  };
}

export function actionResetFilterEmployee() {
  return {
    type: RESET_FILTER,
    payload: null,
  };
}

export function actionSetPageEmployee(page) {
  const stateData = store.getState().employees;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;

  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchEmployees(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
      })
    );
  }

  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
